import * as Long from "long";
import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { IdBalloonOfferTypes } from "../../../../constants/IdBalloonOfferTypes";
import { selectBalloonContentInfo, selectBalloonContentLevelType, selectBalloonInfo, } from "../../../../selectors/selectBalloonInfo";
import { selectOwnPlayerId } from "../../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { actionModalClose } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { actionInventoryInfoRemoveResource } from "../../inventory/actionInventoryInfo";
import { actionBalloonInfo, TypeActionBalloonInfo, } from "../actionBalloonInfo";
export var epicBalloonOfferConsume = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionBalloonInfo.Consume), switchMap(function (action) {
        var state = state$.value;
        var playerId = selectOwnPlayerId(state);
        var balloonLevel = selectBalloonInfo(state).balloonLevel;
        var balloonContentId = action.balloonContentId;
        return deps
            .netSend({
            id: CommandCode.ConsumeBalloon,
            props: {
                balloonContentId: balloonContentId,
                balloonLevel: balloonLevel,
                playerId: playerId,
            },
        })
            .pipe(switchMap(function (res) {
            var actions = [];
            var balloonContentInfo = selectBalloonContentInfo(state);
            if (balloonContentInfo != undefined &&
                balloonContentInfo.balloonOfferTypeId === IdBalloonOfferTypes.Pay) {
                var balloonLevelInfo = selectBalloonContentLevelType(state, balloonContentInfo);
                if (balloonLevelInfo != undefined) {
                    actions.push(actionInventoryInfoRemoveResource([
                        {
                            amount: Long.fromValue(balloonLevelInfo.cost.amount),
                            typeId: balloonLevelInfo.cost.resourceId,
                        },
                    ]));
                }
            }
            if (res.info !== undefined) {
                actions.push(actionBalloonInfo(res.info));
            }
            return from([actionModalClose(IdModal.BalloonOffer)].concat(actions));
        }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/balloon/epics/epicBalloonOfferConsume.ts
// module id = 1900
// module chunks = 3